import { lazy, Suspense } from "react";
import { SEO } from "@/components/SEO";
import ArqNavigation from "@/components/arqera/ArqNavigation";
import ArqHero from "@/components/arqera/ArqHero";
import ArqTrustStrip from "@/components/arqera/ArqTrustStrip";
import ArqProblem from "@/components/arqera/ArqProblem";
import ArqAgenticRisk from "@/components/arqera/ArqAgenticRisk";
import ArqInlineCTA from "@/components/arqera/ArqInlineCTA";
import ArqReadinessAnswers from "@/components/arqera/ArqReadinessAnswers";
import ArqServices from "@/components/arqera/ArqServices";
import ArqEngagementStory from "@/components/arqera/ArqEngagementStory";
import ArqHowItWorks from "@/components/arqera/ArqHowItWorks";
import ArqProofBar from "@/components/arqera/ArqProofBar";
import ArqAbout from "@/components/arqera/ArqAbout";
import ArqFAQ from "@/components/arqera/ArqFAQ";
import ArqBooking from "@/components/arqera/ArqBooking";
import ArqBookingModal from "@/components/arqera/ArqBookingModal";
import ArqFooter from "@/components/arqera/ArqFooter";
import CookieConsent from "@/components/CookieConsent";
import SkipToContent from "@/components/SkipToContent";

const ChatWidget = lazy(() => import("@/components/ChatWidget"));

export default function Index() {
  return (
    <div id="top" className="bg-arq-bg text-arq-text font-body">
      <SEO
        title="ArqeraAI | Operational AI Security for Regulated AI Systems"
        description="ArqeraAI helps regulated and high-stakes organizations assess, remediate, and validate AI, application, and privacy risk across production systems, agents, data flows, vendors, and workflows before those risks become regulatory issues, stalled deals, customer trust failures, or security incidents."
        ogTitle="ArqeraAI | Find What Is Exposed. Fix What Matters. Prove What Is Secure."
        ogDescription="Operational AI Security for organizations deploying AI agents, applications, and workflows across high-stakes business environments."
        canonical="https://arqeraai.com/"
        structuredData={{
          "@context": "https://schema.org",
          "@type": "Organization",
          name: "ArqeraAI",
          url: "https://www.arqeraai.com",
          description: "ArqeraAI is an Operational AI Security firm helping regulated and high-stakes organizations assess, remediate, and validate AI, application, and privacy risk across production systems, agents, data flows, vendors, and workflows.",
          serviceType: [
            "Operational AI Security",
            "AI Security Assessment",
            "AI Risk Remediation & Controls",
            "AI Validation & Evidence",
            "Continuous AI Assurance",
          ],
        }}
      />
      <SkipToContent />
      <ArqNavigation />
      <main id="main-content" tabIndex={-1} className="focus:outline-none">
        <ArqHero />
        <ArqTrustStrip />
        <ArqProblem />
        <ArqAgenticRisk />
        <ArqInlineCTA
          eyebrow="Take the next step"
          headline="Find out what your production AI exposes, and what it would take to prove it secure."
          sub="A focused readiness conversation. No open-ended consulting. Written proposal within 48 hours."
        />
        <ArqReadinessAnswers />
        <ArqHowItWorks />
        <ArqServices />
        <ArqEngagementStory />
        <ArqProofBar />
        <ArqAbout />
        <ArqFAQ />
        <ArqBooking />
      </main>
      <ArqFooter />
      <Suspense fallback={null}>
        <ChatWidget />
      </Suspense>
      <CookieConsent />
      <ArqBookingModal />
    </div>
  );
}
